export default {"src":"/polygon/_next/static/media/balancer-dark.44bb1dbb.svg","height":258,"width":258};